/**
 * i18n Configuration
 * Sets up react-i18next with LT/BE/EN language support
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files directly for bundling
import enTranslations from './translations/en.json';
import ltTranslations from './translations/lt.json';
import beTranslations from './translations/be.json';

const resources = {
  en: {
    translation: enTranslations,
  },
  lt: {
    translation: ltTranslations,
  },
  be: {
    translation: beTranslations,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // Default language
    fallbackLng: 'en',
    supportedLngs: ['en', 'lt', 'be'],
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    react: {
      useSuspense: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;

export type Language = 'en' | 'lt' | 'be';

export const LANGUAGES: { code: Language; label: string; flag: string; name: string }[] = [
  { code: 'en', label: 'EN', flag: '🇬🇧', name: 'English' },
  { code: 'lt', label: 'LT', flag: '🇱🇹', name: 'Lietuvių' },
  { code: 'be', label: 'BE', flag: '🇧🇾', name: 'Беларуская' },
];
